(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["abrazofit-buybox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.AbrazoFit) return;

    var RELEASIT_SELECTORS = [
      '#rsi_buy_now_button',
      '.rsi_buy_now_button',
      '._rsi-buy-now-button',
      '._rsi-buy-now-button-app-block-hook button',
      '._rsi-buy-now-button-app-block-hook a',
      '.rsi-btn-skel'
    ];

    var AF = (window.AbrazoFit = { state: { qty: 1, pay: 'cod', color: 0 }, cfg: {}, colors: [] });

    function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    function cop(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function el(tag, text, child) {
      var e = document.createElement(tag);
      if (text != null) e.textContent = text;
      if (child) e.appendChild(child);
      return e;
    }

    /* Configuración: se fusiona en orden de aparición (la primera sección con el dato manda). */
    function readConfig() {
      var cfg = {};
      $$('[data-af-config]').forEach(function (node) {
        var data;
        try { data = JSON.parse(node.textContent); } catch (e) { return; }
        Object.keys(data).forEach(function (k) {
          if (cfg[k] === undefined || cfg[k] === null || cfg[k] === '') cfg[k] = data[k];
        });
      });
      AF.cfg = cfg;
    }

    /* Color = variante real. Los botones de color (Hero) traen id y precio de su variante. */
    function readColors() {
      AF.colors = $$('[data-af-color-btn]').map(function (b) {
        return { id: Number(b.getAttribute('data-variant-id')), price: Number(b.getAttribute('data-price')) };
      });
      if (AF.state.color >= AF.colors.length) AF.state.color = 0;
    }

    AF.variant = function () {
      var c = AF.colors[AF.state.color];
      if (c && c.id) return c;
      var vs = AF.cfg.variants || [];
      return vs[0] || null;
    };

    function setVariantOnAllForms(variantId, qty) {
      if (!variantId) return;
      var q = parseInt(qty, 10);
      if (!q || q < 1) q = 1;
      $$('form[action$="/cart/add"] input[name="id"], [data-af-form] input[name="id"]').forEach(function (input) { input.value = variantId; });
      $$('input[name="product-id"]').forEach(function (input) { input.value = variantId; });
      /* Releasit lee este input al disparar COD: manda la cantidad real del combo */
      $$('input[name="quantity"]').forEach(function (input) {
        input.value = String(q);
        input.setAttribute('value', String(q));
      });
      if (window.productData) { window.productData.quantity = q; }
      if (window.productData && Array.isArray(window.productData.variants)) {
        var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
        if (v) {
          window.productData.selected_or_first_available_variant = v;
          window.productData.selected_variant = v;
          try {
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
            document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
          } catch (e) {}
        }
      }
    }

    function findReleasitButton() {
      for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
        var node = document.querySelector(RELEASIT_SELECTORS[i]);
        if (node) return node;
      }
      return null;
    }

    AF.render = function () {
      var st = AF.state;
      var L = AF.cfg.labels || {};
      var v = AF.variant();
      var unit = v ? v.price / 100 : 0;

      $$('[data-af-buybox]').forEach(function (box) {
        var picked = null;
        $$('.af-bundle', box).forEach(function (label) {
          var q = Number(label.getAttribute('data-qty'));
          var d = Number(label.getAttribute('data-discount')) || 0;
          var input = label.querySelector('input');
          var on = q === st.qty;
          if (on) picked = { q: q, d: d };
          input.checked = on;
          label.classList.toggle('on', on);
          var bp = label.querySelector('[data-af-bp]');
          if (bp && v) bp.textContent = cop(unit * q - d);
          var tag = label.querySelector('[data-af-tag]');
          if (tag) tag.textContent = (L.save || '') + ' ' + cop(d);
        });

        var totalEl = box.querySelector('[data-af-total]');
        if (totalEl && v) {
          if (!picked) {
            var first = box.querySelector('.af-bundle');
            picked = first ? { q: Number(first.getAttribute('data-qty')), d: Number(first.getAttribute('data-discount')) || 0 } : { q: 1, d: 0 };
          }
          var base = unit * picked.q - picked.d;
          totalEl.textContent = '';
          totalEl.appendChild(el('span', L.total || ''));
          var right = document.createElement('span');
          right.appendChild(el('b', cop(base)));
          right.appendChild(document.createTextNode(' '));
          right.appendChild(el('em', L.codNote || ''));
          totalEl.appendChild(right);
        }
      });

      $$('[data-af-cta]').forEach(function (b) {
        b.textContent = b.getAttribute('data-text-cod');
      });

      if (v) setVariantOnAllForms(v.id, st.qty);
    };

    AF.setColor = function (i) {
      AF.state.color = i;
      document.body.setAttribute('data-af-color', i > 0 ? '1' : '0');
      AF.render();
      try { document.dispatchEvent(new CustomEvent('af:color', { detail: { index: i } })); } catch (e) {}
    };

    function triggerCOD(v, qty) {
      setVariantOnAllForms(v.id, qty);
      setTimeout(function () {
        var releasitBtn = findReleasitButton();
        if (releasitBtn) { releasitBtn.click(); return; }
        var attempts = 0;
        var poll = setInterval(function () {
          attempts++;
          var b = findReleasitButton();
          if (b) { clearInterval(poll); b.click(); return; }
          if (attempts > 30) {
            clearInterval(poll);
            /* Último recurso (no re-lee la variante) */
            if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
              try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
            }
          }
        }, 100);
      }, 50);
    }

    AF.buy = function (btn) {
      var v = AF.variant();
      if (!v) return;
      triggerCOD(v, AF.state.qty);
    };

    AF.init = function () {
      readConfig();
      readColors();
      AF.render();
    };

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('[data-af-buybox]')) return;
      if (t.closest('.af-bundle')) { AF.state.qty = Number(t.value) || 1; AF.render(); }
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var cta = t.closest('[data-af-cta]');
      if (cta) { e.preventDefault(); AF.buy(cta); return; }
      var colorBtn = t.closest('[data-af-color-btn]');
      if (colorBtn) {
        AF.setColor(Number(colorBtn.getAttribute('data-index')) || 0);
        $$('[data-af-color-btn]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === colorBtn ? 'true' : 'false');
        });
      }
    });

    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    ready(AF.init);
    document.addEventListener('shopify:section:load', AF.init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ma-zona-compra"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.MA) return;

    var RELEASIT_SELECTORS = [
      '#rsi_buy_now_button',
      '.rsi_buy_now_button',
      '._rsi-buy-now-button',
      '._rsi-buy-now-button-app-block-hook button',
      '._rsi-buy-now-button-app-block-hook a',
      '.rsi-btn-skel'
    ];

    var MA = (window.MA = { qty: 1 });

    function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    function cop(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

    /* Cada combo trae su propia variante (precio por unidad) y la cantidad real */
    function unitAndVariant() {
      var box = document.querySelector('[data-ma-bundles]');
      var pick = null;
      if (box) {
        $$('.ma-bundle', box).forEach(function (l) { if (Number(l.getAttribute('data-qty')) === MA.qty) pick = l; });
        if (!pick) pick = box.querySelector('.ma-bundle');
      }
      return pick ? { unit: Number(pick.getAttribute('data-unit')) / 100, variant: pick.getAttribute('data-variant') } : { unit: 0, variant: null };
    }

    function setVariantOnAllForms(variantId, qty) {
      if (!variantId) return;
      var q = parseInt(qty, 10);
      if (!q || q < 1) q = 1;
      $$('form[action$="/cart/add"] input[name="id"], [data-ma-form] input[name="id"]').forEach(function (i) { i.value = variantId; });
      $$('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
      /* Releasit lee este input al disparar COD: manda la cantidad real del combo */
      $$('input[name="quantity"]').forEach(function (i) { i.value = String(q); i.setAttribute('value', String(q)); });
      if (window.productData) { window.productData.quantity = q; }
      if (window.productData && Array.isArray(window.productData.variants)) {
        var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
        if (v) {
          window.productData.selected_or_first_available_variant = v;
          window.productData.selected_variant = v;
          try {
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
            document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
          } catch (e) {}
        }
      }
    }

    function findReleasitButton() {
      for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
        var node = document.querySelector(RELEASIT_SELECTORS[i]);
        if (node) return node;
      }
      return null;
    }

    MA.render = function () {
      var uv = unitAndVariant();
      var total = uv.unit * MA.qty;
      var picked = null;
      $$('[data-ma-bundles]').forEach(function (box) {
        var labelSave = box.getAttribute('data-label-save') || '';
        var labelUnit = box.getAttribute('data-label-unit') || '';
        $$('.ma-bundle', box).forEach(function (label) {
          var q = Number(label.getAttribute('data-qty'));
          var d = Number(label.getAttribute('data-discount')) || 0;
          var input = label.querySelector('input');
          input.checked = q === MA.qty;
          if (input.checked) picked = { q: q, d: d };
          var lu = Number(label.getAttribute('data-unit')) / 100;
          var net = lu * q - d;
          var bp = label.querySelector('[data-ma-bp]');
          if (bp) bp.textContent = cop(net);
          var st = label.querySelector('[data-ma-strike]');
          if (st) st.textContent = cop(lu * q);
          var sv = label.querySelector('[data-ma-save]');
          if (sv) sv.textContent = labelSave + ' ' + cop(d);
          var sub = label.querySelector('[data-ma-sub]');
          if (sub) {
            var desc = label.getAttribute('data-desc') || '';
            sub.textContent = (q > 1 ? cop(net / q) + ' ' + labelUnit + (desc ? ' · ' : '') : '') + desc;
          }
        });
      });
      if (picked) total = uv.unit * picked.q - picked.d;
      $$('[data-ma-cta]').forEach(function (btn) {
        var tpl = MA.qty > 1 ? btn.getAttribute('data-tpl-many') : btn.getAttribute('data-tpl-one');
        var l2 = btn.querySelector('[data-ma-l2]');
        if (l2 && tpl) l2.textContent = tpl.replace('{n}', String(MA.qty)).replace('{total}', cop(total));
      });
      setVariantOnAllForms(uv.variant, MA.qty);
    };

    function triggerCOD() {
      var uv = unitAndVariant();
      setVariantOnAllForms(uv.variant, MA.qty);
      setTimeout(function () {
        var btn = findReleasitButton();
        if (btn) { btn.click(); return; }
        var attempts = 0;
        var poll = setInterval(function () {
          attempts++;
          var b = findReleasitButton();
          if (b) { clearInterval(poll); b.click(); return; }
          if (attempts > 30) {
            clearInterval(poll);
            /* Último recurso (no re-lee la variante) */
            if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
              try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
            }
          }
        }, 100);
      }, 50);
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.ma-bundle')) { MA.qty = Number(t.value) || 1; MA.render(); }
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var cta = t.closest('[data-ma-cta]');
      if (cta) { e.preventDefault(); triggerCOD(); }
    });

    /* Aviso discreto con el stock real, cada 30-45 s */
    function initToast(el) {
      if (el.getAttribute('data-ma-ready')) return;
      el.setAttribute('data-ma-ready', '1');
      var textEl = el.querySelector('[data-ma-toast-text]');
      textEl.textContent = textEl.getAttribute('data-text');
      var first = (Number(el.getAttribute('data-first')) || 7) * 1000;
      var min = (Number(el.getAttribute('data-min')) || 30) * 1000;
      var max = Math.max(min, (Number(el.getAttribute('data-max')) || 45) * 1000);
      var visible = (Number(el.getAttribute('data-visible')) || 4.5) * 1000;
      var hideT = null;
      function show() {
        if (!document.body.contains(el)) return;
        el.classList.add('show');
        clearTimeout(hideT);
        hideT = setTimeout(function () { el.classList.remove('show'); }, visible);
        setTimeout(show, min + Math.random() * (max - min));
      }
      setTimeout(show, first);
    }

    MA.init = function () {
      MA.render();
      $$('[data-ma-toast]').forEach(initToast);
    };
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    ready(MA.init);
    document.addEventListener('shopify:section:load', MA.init);
  })();
  } catch(e) { console.error(e); }
})();

})();
